import React from 'react';
import { SVGProps } from './types';

function SendIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M12 16V8.763M9 11l3-3 3 3"
      />
    </svg>
  );
}

export { SendIcon };
